import React from 'react';
import { useNavigate } from 'react-router-dom';

const C = {
  charcoal: 'var(--kahla-charcoal, #2a2a2a)',
  light: 'var(--kahla-text-light, #8a8578)',
  border: 'var(--kahla-border, #e8e2d8)',
  cream: 'var(--kahla-cream-light, #faf8f5)',
  gold: '#cf9a3d',
};

const Eyebrow = ({ children }) => (
  <p style={{ fontFamily: 'Playfair Display, serif', fontSize: 11, letterSpacing: '0.32em', textTransform: 'uppercase', color: C.gold, margin: '0 0 14px' }}>{children}</p>
);

const H2 = ({ children }) => (
  <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: 26, fontWeight: 500, color: C.charcoal, margin: '64px 0 18px', letterSpacing: '-0.005em' }}>{children}</h2>
);

const H3 = ({ children }) => (
  <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: 17, fontWeight: 500, color: C.charcoal, margin: '28px 0 10px' }}>{children}</h3>
);

const P = ({ children, italic }) => (
  <p style={{ fontFamily: italic ? 'Cormorant Garamond, serif' : 'inherit', fontStyle: italic ? 'italic' : 'normal', fontSize: italic ? 17 : 15, lineHeight: 1.75, color: italic ? C.light : '#4a463e', margin: '0 0 14px', maxWidth: 720 }}>{children}</p>
);

const MODULES = [
  { name: 'Library', verb: 'Collect', role: 'Jedno źródło wszystkich materiałów wizualnych — obrazy, kolekcje, tagi. Element Core Workspace.', status: 'Istnieje', tone: '#4a7c59' },
  { name: 'Client Space', verb: 'Remember', role: 'Pamięć o kliencie, niezależna od projektów: profil, historia wizyt, before/after, dokumenty, oś czasu, tagi klienta.', status: 'Do zbudowania', tone: '#b0483a' },
  { name: 'Boards', verb: 'Collaborate', role: 'Współpraca projektowa: moodboardy, konwersacja, akceptacje, decyzje finalne. Private Space projektu zostaje tutaj.', status: 'Istnieje — serce aplikacji', tone: '#4a7c59' },
  { name: 'Creator Space', verb: 'Think', role: 'Prywatny system operacyjny twórcy: pomysły, zadania, oś czasu, dziennik, projekty, organizacja AI. Niezależny moduł — NIE dashboard.', status: 'Do zbudowania', tone: '#b0483a' },
  { name: 'Archives', verb: 'Own', role: 'Własność danych: eksport tablicy, klienta lub całego workspace — zawsze. Element Core Workspace.', status: 'Częściowo (PDF/ZIP per-tablica)', tone: '#cf9a3d' },
];

const PROFESSIONS = [
  { name: 'Beauty', modules: 'Library · Client Space · Creator Space' },
  { name: 'Fotograf', modules: 'Library · Client Space · Boards · Creator Space' },
  { name: 'Wedding Planner', modules: 'Library · Client Space · Boards · Creator Space' },
];

const PRICING = [
  { layer: 'Fundament', title: 'Core Workspace', items: 'Workspace · Library · Basic Storage · Archives · Synchronizacja', note: 'Zawsze w cenie bazowej.' },
  { layer: 'Moduły', title: 'Włączasz, czego potrzebujesz', items: 'Client Space · Boards · Creator Space', note: 'Moduł = kompletna funkcjonalność. Żadnych okrojonych wersji.' },
  { layer: 'Infrastruktura', title: 'Rozszerzasz tylko gdy trzeba', items: 'Storage · AI · Członkowie zespołu · Branding', note: 'Wyceniana osobno — reprezentuje realne koszty operacyjne.' },
];

const JOURNEYS = [
  ['Powracająca klientka — Remember', 'Anna wraca po roku. Dashboard → Client Space → profil Anny: oś czasu, historia wizyt, before/after, tag „ciepłe tony". Nowa tablica z profilu — kontekst od pierwszej sekundy.'],
  ['Poranek twórczyni — Think', 'Dashboard (punkt wejścia) → Creator Space. Tam jej prywatny system: zadania na dziś, pomysł z obrazami z Library, wpis w dzienniku.'],
  ['Współpraca — Collaborate', 'Dashboard → Boards → tablica → link dla klienta → reakcje, konwersacja, Final Decision. Prywatne przypomnienia o projekcie w Private Space tej tablicy.'],
  ['Koniec współpracy — Own', 'Archives → „Eksportuj klienta" → ZIP z całą relacją. Tablica wygasa, dane zostają u Ciebie.'],
  ['Onboarding — adaptacja', 'Nowa twórczyni wybiera profesję → preset aktywnych modułów → nawigacja i dashboard od pierwszego dnia skrojone pod nią.'],
];

const ROADMAP = [
  ['Faza 0', 'Fundament modularności', 'Model aktywnych modułów, modularna nawigacja, minimalny Dashboard-wejście, onboarding profesji, czystka terminologii.'],
  ['Faza 1', 'Client Space', 'Encja klienta, profil, historia wizyt, before/after, pliki, oś czasu relacji, przypisywanie tablic.'],
  ['Faza 2', 'Wewnętrzne dashboardy modułów', 'Boards dostaje własny dashboard (obecna lista tablic); root Dashboard pozostaje minimalny.'],
  ['Faza 3', 'Creator Space', 'Pomysły, zadania, oś czasu, dziennik, projekty, organizacja AI — niezależny prywatny system twórcy.'],
  ['Faza 4', 'Archives', 'Eksport tablicy / klienta / workspace, historia eksportów.'],
  ['Faza 5', 'Rozliczenia modularne', 'Migracja z planów na Core + Moduły + Infrastruktura.'],
];

export default function AdminBlueprint() {
  const navigate = useNavigate();
  return (
    <div data-testid="admin-blueprint-page" style={{ minHeight: '100vh', background: C.cream }}>
      <div style={{ maxWidth: 860, margin: '0 auto', padding: '72px 32px 120px' }}>
        <button
          type="button"
          data-testid="blueprint-back-btn"
          onClick={() => navigate('/admin')}
          style={{ background: 'transparent', border: 'none', padding: 0, marginBottom: 40, cursor: 'pointer', fontFamily: 'Playfair Display, serif', fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase', color: C.light }}
        >← Panel admina</button>

        <Eyebrow>Blueprint · Wersja 2.1 · Oczekuje na akceptację</Eyebrow>
        <h1 style={{ fontFamily: 'Playfair Display, serif', fontSize: 44, fontWeight: 400, color: C.charcoal, margin: '0 0 18px', lineHeight: 1.15 }}>
          Maestra — Creative Operating System
        </h1>
        <P italic>Modularna przestrzeń pracy, która zamienia cyfrowy chaos twórcy w harmonię. Nie „platforma moodboardowa", nie „CRM" — system operacyjny pracy twórczej. Harmony over Chaos.</P>

        <H2>1 · Filozofia — trzy prawdy produktu</H2>
        <div style={{ display: 'grid', gap: 12 }}>
          {[['Tablica jest wydarzeniem', 'ma początek i koniec — sesja, projekt, kampania.'],
            ['Klient jest relacją', 'trwa dłużej niż jedna tablica — wraca, ma historię i preferencje.'],
            ['Twórca jest osią', 'jego myśli, pomysły i zadania istnieją niezależnie od klientów i tablic.']].map(([t, d]) => (
            <div key={t} style={{ borderLeft: `2px solid ${C.gold}`, padding: '4px 0 4px 18px' }}>
              <span style={{ fontFamily: 'Playfair Display, serif', fontSize: 16, color: C.charcoal }}>{t}</span>
              <span style={{ fontSize: 14, color: C.light }}> — {d}</span>
            </div>
          ))}
        </div>
        <P italic>Zasada architektoniczna: każdy moduł jest właścicielem swojego doświadczenia. Library zarządza biblioteką, Client Space klientami, Boards projektami, Creator Space osobistą produktywnością. Każdy moduł ma własny wewnętrzny dashboard.</P>

        <H2>2 · Pięć modułów — czasowniki pracy twórczej</H2>
        <div data-testid="blueprint-modules" style={{ display: 'grid', gap: 14 }}>
          {MODULES.map((m) => (
            <div key={m.name} style={{ background: '#fff', border: `1px solid ${C.border}`, padding: '20px 24px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap', gap: 8 }}>
                <div>
                  <span style={{ fontFamily: 'Playfair Display, serif', fontSize: 19, color: C.charcoal }}>{m.name}</span>
                  <span style={{ fontFamily: 'Cormorant Garamond, serif', fontStyle: 'italic', fontSize: 15, color: C.gold, marginLeft: 10 }}>{m.verb}</span>
                </div>
                <span style={{ fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: m.tone }}>{m.status}</span>
              </div>
              <p style={{ fontSize: 14, lineHeight: 1.65, color: '#4a463e', margin: '8px 0 0' }}>{m.role}</p>
            </div>
          ))}
        </div>

        <H2>3 · Separacja koncepcji — Private Space ≠ Client Space</H2>
        <div data-testid="blueprint-separation" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 14 }}>
          <div style={{ background: '#fff', border: `1px solid ${C.border}`, padding: '20px 24px' }}>
            <H3>Client Space</H3>
            <p style={{ fontSize: 14, lineHeight: 1.7, color: '#4a463e', margin: 0 }}>Informacje o kliencie, dostępne niezależnie od projektów:<br />profil · historia wizyt · zdjęcia before/after · dokumenty · oś czasu · tagi klienta.</p>
          </div>
          <div style={{ background: '#fff', border: `1px solid ${C.border}`, padding: '20px 24px' }}>
            <H3>Board Private Space</H3>
            <p style={{ fontSize: 14, lineHeight: 1.7, color: '#4a463e', margin: 0 }}>Informacje o jednym konkretnym projekcie:<br />przypomnienia · checklista projektowa · tymczasowe pomysły · notatki tylko o tej tablicy. Zostają przypięte do tablicy.</p>
          </div>
        </div>
        <P italic>Te dwa pojęcia nigdy nie zostaną połączone. Prywatne notatki tablic nie migrują do Client Space.</P>

        <H2>4 · Creator Space — niezależny moduł, nie dashboard</H2>
        <P>Creator Space to <strong>prywatny system operacyjny użytkownika</strong>: Pomysły · Zadania · Oś czasu · Dziennik · Projekty · Organizacja AI. To nie jest dashboard Maestry — to osobna przestrzeń, którą włączasz lub wyłączasz. Kto jej nie potrzebuje, po prostu ją wyłącza i znika całkowicie.</P>

        <H2>5 · Dashboard — minimalny punkt wejścia</H2>
        <P>Główny Dashboard <strong>nie jest dashboardem produktywności</strong>. Jest punktem wejścia — pozwala wejść do przestrzeni, której potrzebujesz:</P>
        <pre style={{ background: '#2a2a2a', color: '#e8e2d8', padding: '24px 28px', fontSize: 13, lineHeight: 1.8, overflowX: 'auto', fontFamily: 'ui-monospace, monospace' }}>
{`Workspace
  Library
  Client Space
  Boards
  Creator Space`}
        </pre>
        <P italic>Każdy moduł zarządza swoim własnym wewnętrznym dashboardem. Root Dashboard nigdy nie może zostać przeciążony.</P>

        <H2>6 · Filozofia cenowa — Core + Moduły + Infrastruktura</H2>
        <P>Architektura plan-centryczna zostaje zastąpiona architekturą modularną w trzech warstwach:</P>
        <div data-testid="blueprint-pricing" style={{ display: 'grid', gap: 14 }}>
          {PRICING.map((p) => (
            <div key={p.layer} style={{ background: '#fff', border: `1px solid ${C.border}`, padding: '20px 24px' }}>
              <p style={{ fontSize: 10, letterSpacing: '0.22em', textTransform: 'uppercase', color: C.gold, margin: '0 0 6px' }}>{p.layer}</p>
              <p style={{ fontFamily: 'Playfair Display, serif', fontSize: 17, color: C.charcoal, margin: '0 0 6px' }}>{p.title}</p>
              <p style={{ fontSize: 14, color: '#4a463e', margin: '0 0 6px' }}>{p.items}</p>
              <p style={{ fontFamily: 'Cormorant Garamond, serif', fontStyle: 'italic', fontSize: 14.5, color: C.light, margin: 0 }}>{p.note}</p>
            </div>
          ))}
        </div>

        <H2>7 · Modularność — widoczność</H2>
        <P>Moduły aktywne pojawiają się w nawigacji. Nieaktywne <strong>znikają całkowicie z interfejsu</strong> — nie są wyszarzone, nie istnieją. Celem nie jest ograniczanie funkcji, lecz redukcja cyfrowego szumu. Każdy workspace ma się czuć skrojony pod profesję twórcy.</P>
        <div style={{ display: 'grid', gap: 10, margin: '18px 0' }}>
          {PROFESSIONS.map((p) => (
            <div key={p.name} style={{ display: 'flex', gap: 18, alignItems: 'baseline', borderBottom: `1px solid ${C.border}`, paddingBottom: 10 }}>
              <span style={{ fontFamily: 'Playfair Display, serif', fontSize: 15, color: C.charcoal, minWidth: 150 }}>{p.name}</span>
              <span style={{ fontSize: 13, color: C.light, letterSpacing: '0.04em' }}>{p.modules}</span>
            </div>
          ))}
        </div>

        <H2>8 · Architektura informacji</H2>
        <pre style={{ background: '#2a2a2a', color: '#e8e2d8', padding: '24px 28px', fontSize: 13, lineHeight: 1.8, overflowX: 'auto', fontFamily: 'ui-monospace, monospace' }}>
{`Maestra
├── Dashboard        minimalny punkt wejścia
├── Library          obrazy · kolekcje · tagi (Core)
├── Client Space     Profil · Wizyty · Before/After · Pliki · Oś czasu
├── Boards           edytor + Client View + Private Space projektu
├── Creator Space    Pomysły · Zadania · Oś czasu · Dziennik · Projekty · AI
└── Archives         eksport tablicy / klienta / workspace (Core)`}
        </pre>
        <P italic>Kluczowa zmiana danych: klient staje się encją pierwszej klasy — tablica dostaje opcjonalne client_id. Istniejące tablice działają bez zmian.</P>

        <H2>9 · User journeys</H2>
        <div style={{ display: 'grid', gap: 20 }}>
          {JOURNEYS.map(([t, d]) => (
            <div key={t}>
              <p style={{ fontFamily: 'Playfair Display, serif', fontSize: 15, color: C.charcoal, margin: '0 0 4px' }}>{t}</p>
              <p style={{ fontSize: 14, lineHeight: 1.65, color: C.light, margin: 0, maxWidth: 700 }}>{d}</p>
            </div>
          ))}
        </div>

        <H2>10 · Do wygaszenia</H2>
        <P>Terminologia „moodboard platform" i „CRM" (i18n, Guide, landing) · martwe pola instrukcji w edytorze szablonów · landing page do przepisania pod nową narrację · architektura plan-centryczna (długoterminowo, na rzecz Core + Moduły + Infrastruktura).</P>

        <H2>Roadmapa</H2>
        <div data-testid="blueprint-roadmap" style={{ display: 'grid', gap: 0 }}>
          {ROADMAP.map(([phase, title, desc]) => (
            <div key={phase} style={{ display: 'flex', gap: 20, padding: '16px 0', borderBottom: `1px solid ${C.border}` }}>
              <span style={{ fontFamily: 'Playfair Display, serif', fontSize: 12, letterSpacing: '0.18em', textTransform: 'uppercase', color: C.gold, minWidth: 70, paddingTop: 2 }}>{phase}</span>
              <div>
                <p style={{ fontFamily: 'Playfair Display, serif', fontSize: 16, color: C.charcoal, margin: '0 0 4px' }}>{title}</p>
                <p style={{ fontSize: 13.5, lineHeight: 1.6, color: C.light, margin: 0 }}>{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 56, border: `1px dashed ${C.gold}`, padding: '22px 26px', background: '#fff' }}>
          <p style={{ fontFamily: 'Cormorant Garamond, serif', fontStyle: 'italic', fontSize: 16, lineHeight: 1.7, color: C.charcoal, margin: 0 }}>
            Implementacja rozpocznie się dopiero po Twojej akceptacji tego blueprintu. Kolejność modułów zatwierdzona: Client Space → Creator Space → Archives.
          </p>
        </div>
      </div>
    </div>
  );
}
